import { buttonVariants as e, buttonRootCommonStyles as s } from "../Button/Button.variants.js";
import { compose as i } from "../../tailwind-buddy-interface.js";
const o = {
  xs: "sm",
  sm: "md",
  md: "md",
  lg: "md",
  xl: "lg"
}, a = s, r = i({
  slots: {
    root: `
      inline-flex
      items-center
      justify-center
    `,
    label: "",
    icon: "shrink-0"
  },
  variants: {
    size: {
      xs: "p-050 rounded-xs",
      sm: "p-050 rounded-sm",
      md: "p-100 rounded-sm",
      lg: "p-150 rounded-md",
      xl: "p-150 rounded-md"
    }
  },
  compoundVariants: [
    // variant="contained" / isDisabled="false" / isDisabledFocusable="false"
    {
      conditions: {
        variant: "contained",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: a.variantContainedIsDisabledFalseIsDisabledFocusableFalse
      }
    },
    // variant="contained"
    {
      conditions: {
        variant: "contained"
      },
      class: a.variantContained
    },
    // variant="text"
    {
      conditions: {
        variant: "text",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: a.variantText
      }
    },
    // variant="contained" / appearance="default"
    {
      conditions: {
        appearance: "default",
        variant: "contained",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: `
        ${a.variantContainedAppearanceDefault}
        text-icon-color-primary
      `
    },
    // variant="contained" / appearance="primary"
    {
      conditions: {
        appearance: "primary",
        variant: "contained",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: `
        ${a.variantContainedAppearancePrimary}
        text-icon-color-primary-inverse
      `
    },
    // variant="contained" / appearance="destructive"
    {
      conditions: {
        appearance: "destructive",
        variant: "contained",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: `
        ${a.variantContainedAppearanceDestructive}
        text-color-scheme-functional-negative-500
      `
    },
    // variant="text" / appearance="default"
    {
      conditions: {
        appearance: "default",
        variant: "text",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: `
        ${a.variantTextAppearanceDefault}
        text-icon-color-primary
      `
    },
    // variant="text" + appearance="primary"
    {
      conditions: {
        appearance: "primary",
        variant: "text",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: `
        ${a.variantTextAppearancePrimary}
        text-color-scheme-brand-primary-500
      `
    },
    // variant="text" / appearance="destructive"
    {
      conditions: {
        appearance: "destructive",
        variant: "text",
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: `
        ${a.variantTextAppearanceDestructive}
        text-color-scheme-functional-negative-500
      `
    },
    // variant="contained" / appearance="default" / enableGroupHover="true"
    {
      conditions: {
        appearance: "default",
        variant: "contained",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: a.variantContainedAppearanceDefaultEnableGroupHover
    },
    // variant="contained" / appearance="primary" / enableGroupHover="true"
    {
      conditions: {
        appearance: "primary",
        variant: "contained",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: a.variantContainedAppearancePrimaryEnableGroupHover
    },
    // variant="contained" / appearance="destructive" / enableGroupHover="true"
    {
      conditions: {
        appearance: "destructive",
        variant: "contained",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: a.variantContainedAppearanceDestructiveEnableGroupHover
      }
    },
    // variant="text" / appearance="default" / enableGroupHover="true"
    {
      conditions: {
        appearance: "default",
        variant: "text",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: a.variantTextAppearanceDefaultEnableGroupHover
      }
    },
    // variant="text" / appearance="primary" / enableGroupHover="true"
    {
      conditions: {
        appearance: "primary",
        variant: "text",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: a.variantTextAppearancePrimaryEnableGroupHover
      }
    },
    // variant="text" / appearance="destructive" / enableGroupHover="true"
    {
      conditions: {
        appearance: "destructive",
        variant: "text",
        enableGroupHover: !0,
        isDisabled: !1,
        isDisabledFocusable: !1
      },
      class: {
        root: a.variantTextAppearanceDestructiveEnableGroupHover
      }
    },
    // variant="contained" / isDisabled="true"
    {
      conditions: {
        variant: "contained",
        isDisabled: !0
      },
      class: {
        root: `
          ${a.variantContainedIsDisabled}
          text-color-scheme-interactive-disabled-400
        `
      }
    },
    // variant="contained" / isDisabledFocusable="true"
    {
      conditions: {
        variant: "contained",
        isDisabledFocusable: !0
      },
      class: {
        root: `
          ${a.variantContainedIsDisabledFocusable}
          text-color-scheme-interactive-disabled-400
        `
      }
    },
    // variant="text" / isDisabled="true"
    {
      conditions: {
        variant: "text",
        isDisabled: !0
      },
      class: {
        root: `
          ${a.variantTextIsDisabled}
          text-color-scheme-interactive-disabled-400
        `
      }
    },
    // variant="text" / isDisabledFocusable="true "
    {
      conditions: {
        variant: "text",
        isDisabledFocusable: !0
      },
      class: {
        root: `
          ${a.variantTextIsDisabledFocusable}
          text-color-scheme-interactive-disabled-400
        `
      }
    }
  ],
  defaultVariants: e.definition().defaultVariants,
  responsiveVariants: ["size"]
})();
export {
  o as buttonIconSizeMap,
  r as buttonIconVariants
};
